type Options = {
  maxWait: number | null;
  leading: boolean;
  trailing: boolean;
};

export const debounce = <TArgs extends any[]>(
  fn: (...args: TArgs) => void,
  wait = 100,
  { maxWait = null, leading = false, trailing = true }: Partial<Options> = {}
) => {
  let _args: TArgs | null = null;

  let _timeout: number | null = null;
  let _maxWaitTimeout: number | null = null;

  const _call = () => {
    fn(..._args!);
  };

  const _clearTimeouts = () => {
    if (_timeout !== null) {
      clearTimeout(_timeout);
      _timeout = null;
    }

    if (_maxWaitTimeout !== null) {
      clearTimeout(_maxWaitTimeout);
      _maxWaitTimeout = null;
    }
  };

  const callOnTimeout = () => {
    _clearTimeouts();

    if (trailing) {
      _call();
    }
  };

  const debounced = function (...args: TArgs) {
    _args = args;

    if (_timeout === null) {
      _timeout = window.setTimeout(callOnTimeout, wait);

      if (leading) {
        _call();
      }
    }

    if (maxWait !== null && _maxWaitTimeout === null) {
      _maxWaitTimeout = window.setTimeout(callOnTimeout, maxWait);
    }
  };

  debounced.cancel = _clearTimeouts;

  debounced.flush = () => {
    if (_timeout === null) {
      return;
    }

    _clearTimeouts();
    _call();
  };

  return debounced;
};
